module.exports = __webpack_public_path__ + "img/bg2.9c5b70bd.png";